module.exports = __webpack_public_path__ + "/login_ui/img/ao-36c4fa3d8f153a0ad3d633715ea08f6e.svg";